import type { SVGProps } from 'react';
const SvgGridOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#grid_off_svg__a)">
      <path
        fill="currentColor"
        d="M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8Zm8 0h4v4h-4V4ZM1.27 1.27 0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27ZM10 12.55 11.45 14H10v-1.45Zm-6-6L5.45 8H4V6.55ZM8 20H4v-4h4v4Zm0-6H4v-4h3.45l.55.55V14Zm6 6h-4v-4h3.45l.55.54V20Zm2 0v-1.46L17.46 20H16Z"
      />
    </g>
    <defs>
      <clipPath id="grid_off_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGridOff;
